import(/* webpackMode: "eager", webpackExports: ["App"] */ "__barrel_optimize__?names=App!=!/www/wwwroot/STARY-bc/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["ConfigProvider"] */ "__barrel_optimize__?names=ConfigProvider!=!/www/wwwroot/STARY-bc/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/STARY-bc/node_modules/@ant-design/nextjs-registry/es/AntdRegistry.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/STARY-bc/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/www/wwwroot/STARY-bc/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/STARY-bc/src/app/[locale]/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/STARY-bc/src/components/Common/GoToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/STARY-bc/src/components/Cookie/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/STARY-bc/src/components/Footer/page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/STARY-bc/src/components/Header/Menu/MenuTwo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/STARY-bc/src/components/Header/TopNav/TopNavOne.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/STARY-bc/src/components/homeComponent/discount2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/STARY-bc/src/components/Mobile/footer-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/STARY-bc/src/components/Modal/ModalCustomer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/STARY-bc/src/components/Modal/ModalInquiry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/STARY-bc/src/components/Other/CustomerBtn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CategoryProvider"] */ "/www/wwwroot/STARY-bc/src/context/CategoriesContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/STARY-bc/src/context/channel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModalCustomerProvider"] */ "/www/wwwroot/STARY-bc/src/context/CustomerContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModalInquiryProvider"] */ "/www/wwwroot/STARY-bc/src/context/ModalInquiryContext.tsx");
